
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search_gcse",
      function () {
        return require("private-next-pages/search_gcse/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search_gcse"])
      });
    }
  